import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { raiseToast } from '../toast/toast'
import { getNotifications } from '../../../api/adminNotificationMessage'


export const fetchNotifications = createAsyncThunk('user/getNotifications', async (params, { dispatch }) => {
    const response = await getNotifications(params)
    if (response.failure) {
        dispatch(raiseToast({ severity: 'error', detail: response.data.error }))
        throw Error()
    }
    console.log("fetchNotifications", response)
    return response.data
})

export const notificationsSlice = createSlice({
    name: 'notifications',
    initialState: {
        loading: false,
        notifications: []
    },
    reducers: {
        updateNotifications: (state, action) => {
            state.notifications = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchNotifications.fulfilled, (state, action) => {
                state.loading = false
                state.notifications = action.payload.data
            })
            .addCase(fetchNotifications.pending, (state) => {
                state.loading = true
            })
            .addCase(fetchNotifications.rejected, (state) => {
                state.loading = false
            })
    }
})

export const { updateNotifications } = notificationsSlice.actions
export default notificationsSlice.reducer
